var klaviyo = klaviyo || [];
klaviyo.init(window.klaviyoSettings.init);
klaviyo.enable("backinstock", window.klaviyoSettings.backInStock);

// NRT-294: rebuild the BIS widget after a fake variant swap.
// The Klaviyo onsite.js widget fetches the product JSON, scans for .klaviyo-bis-trigger
// and builds its modal iframe once, on page load. klaviyo.enable() is a no-op once the
// component is cached (inside a closure, not reachable from window.klaviyoBIS), so after
// the AJAX content swap the trigger never reappears and the modal shows the old product.
// The only reliable refresh is to fully re-inject onsite.js so a fresh widget reads the
// (already replaceState-updated) URL and re-scans the swapped DOM.
document.addEventListener('fakeVariant:loaded', function () {
  if (!window.klaviyoSettings) return;

  // Klaviyo resolves the selected variant from the first input[name="id"] in the DOM
  // (the body-level input added for SD-4955) — point it at the swapped product's variant
  var bodyInput = document.querySelector('body > input[type="hidden"][name="id"]');
  var formInput = document.querySelector('.js-product-main input[name="id"]');
  if (bodyInput && formInput) {
    bodyInput.value = formInput.value;
  }

  // Remove the modal iframe(s) built for the previous product. The old widget instance
  // survives in its closure, but with its iframe detached its show calls are harmless —
  // this prevents a duplicate modal opening alongside the fresh widget's.
  document.querySelectorAll('#klaviyo-bis-iframe').forEach(function (el) {
    el.remove();
  });

  // Drop the old global and re-download onsite.js (cache-busted) so a fresh widget builds
  delete window.klaviyoBIS;
  document.querySelectorAll('script[src*="a.klaviyo.com/media/js/onsite/onsite.js"]').forEach(function (el) {
    el.remove();
  });

  var script = document.createElement('script');
  script.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js?nrt294=' + Date.now();
  script.onload = function () {
    klaviyo.init(window.klaviyoSettings.init);
    klaviyo.enable("backinstock", window.klaviyoSettings.backInStock);
  };
  document.head.appendChild(script);
});
